import { useTranslation } from 'react-i18next'

import { Checkbox, Text } from '@reveni-io/reveni-ui'

import { disableRefundMethodOptions } from './constants'
import * as Styles from './styles'

const isMethodSelected = (refundMethods, method) => {
  return (refundMethods || []).some(item => item.method === method)
}

const toggleMethod = (refundMethods, method, checked) => {
  const current = refundMethods || []
  if (checked) {
    return [...current, { method }]
  }
  return current.filter(item => item.method !== method)
}

const DisableRefundMethodsConfig = ({ config, onChangeConfig, disabled, errors = [] }) => {
  const { t } = useTranslation()

  const hasError = errors.some(e => e.type === 'actionDisableRefundMethodsEmpty')

  return (
    <Styles.Container>
      <Text type="bodyMBold">{t('Métodos de reembolso')}</Text>
      <Styles.CheckboxesContainer>
        {disableRefundMethodOptions.map(option => (
          <Checkbox
            key={option.value}
            label={t(option.labelKey)}
            checked={isMethodSelected(config.refund_methods, option.value)}
            onChange={e =>
              onChangeConfig({ refund_methods: toggleMethod(config.refund_methods, option.value, e.target.checked) })
            }
            disabled={disabled}
            error={hasError}
          />
        ))}
      </Styles.CheckboxesContainer>
    </Styles.Container>
  )
}

export default DisableRefundMethodsConfig
